import React, { Fragment } from 'react'

import { Button, Input } from '../primitives'

const ButtonLabel = Button.withComponent('label')

const FileInput = ({ uploadFile, uploadStatus }) => (
	<Fragment>
		<ButtonLabel disabled={uploadStatus === 'uploading'} htmlFor="file-upload">Upload lastException File</ButtonLabel>
		<Input id="file-upload" type="file" onChange={uploadFile} />
	</Fragment>
)

export default FileInput



// WEBPACK FOOTER //
// ./src/components/FileInput.js